import { of } from "rxjs";
import { catchError, filter, map, mergeMap } from "rxjs/operators";

import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { IError } from "../../../redux/actions/errorHandlingAction";
import { isActionType, isOneOfActionTypes } from "../../../redux/action.functions";

import * as actions from "./campaign-briefs.actions";
import { CampaignBriefsActions } from "./campaign-briefs.actions";
import * as services from "../services/campaign-briefs.services";
import { ICampaignBriefsFilters } from "../types/campaign-briefs.interface";

const fetchBriefs: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isOneOfActionTypes([CampaignBriefsActions.Fetch, CampaignBriefsActions.ChangePage])),
    map((action) => action.payload),
    mergeMap((filters: ICampaignBriefsFilters) =>
      services.fetchBriefs(filters).pipe(
        map((results) => actions.fetchSuccess(results)),
        catchError((error: IError) => of(actions.fetchFailure(error)))
      )
    )
  );

const fetchFilterOptions: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(CampaignBriefsActions.FetchFilters)),
    mergeMap(() =>
      services.getCampaignBriefFilterOptions().pipe(
        map((results) => actions.fetchFiltersSuccess(results)),
        catchError((error: IError) => of(actions.fetchFiltersFailure(error)))
      )
    )
  );

export const CampaignBriefsEffects = [fetchBriefs, fetchFilterOptions];
